import React, { FunctionComponent, ReactElement } from "react";

import "./styles.scss";

type ResetPasswordButtonProp = {
  disabled?: boolean;
  type?: "select" | "normal" | "plain-text" | "submit";
  onClick?: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined;
  label?: string;
  image?: string;
  style?: object;
  isSel?: boolean;
  customClass?: string;
  children?: React.ReactNode;
};

export const ResetPasswordButton: FunctionComponent<ResetPasswordButtonProp> = (props): ReactElement => {
  const { disabled, type = "normal", onClick, label, image, style, isSel, customClass = "", children } = props;

  return (
    <button style={style} disabled={disabled} onClick={onClick} className={`reset-password-button ${type} ${isSel ? "selected" : ""} ${customClass}`}>
      {image && image.length > 0 && <img className="reset-password-button__icon" src={image} />}
      {label}
      {type === "select" && <img className="reset-password-button__caret" src={require("src/assets/resetPassword/caret-down-black.png")} />}
      {children}
    </button>
  );
};

export default ResetPasswordButton;
